
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from "../system/index.js";
import type {
  MediaAsset,
  ComponentAccordion,
  ComponentColumnCardGroup,
  ComponentFeature,
  ComponentInfoCardGroup,
} from "./index.js";
import type { PageElements } from "../../../../../kontent/content-type-snippets/index.js";

/**
 * 📄 Page // General
 *
 * Id: 7d8ee9b7-7189-4e8f-92c6-1337339dc4ea
 * Codename: general_page
 */
export type PageGeneral = CoreContentType<
  PageGeneralElementCodenames,
  {
    /**
     * Title
     *
     * Type: text
     * Required: true
     * Codename: title
     * Id: b5d31869-f14a-4c42-a9b5-eac58ca08742
     */
    readonly title: Elements.TextElement;
    /**
     * Intro
     *
     * Type: rich_text
     * Required: true
     * Codename: intro
     * Id: d4ccd1f6-73e2-49b4-87cf-7ad8ede7d679
     */
    readonly intro: Elements.RichTextElement<CoreContentType>;
    /**
     * Image
     *
     * Type: modular_content
     * Required: true
     * Codename: image
     * Id: e255ab62-f2d0-477e-874b-90b156a5ac55
     */
    readonly image: Elements.LinkedItemsElement<MediaAsset>;
    /**
     * Hero Type
     *
     * Type: multiple_choice
     * Required: true
     * Codename: hero_type
     * Id: a644485c-2f31-4c05-a812-2145230f9a59
     */
    readonly hero_type: Elements.MultipleChoiceElement<
      "image_background" | "no_asset_left_aligned" | "no_asset_centre_aligned"
    >;
    /**
     * Sections
     *
     * Type: modular_content
     * Required: false
     * Codename: sections
     * Id: 43702245-bcd1-4af4-9177-297dd90774be
     */
    readonly sections: Elements.LinkedItemsElement<
      | ComponentAccordion
      | ComponentColumnCardGroup
      | ComponentFeature
      | ComponentInfoCardGroup
    >;
    /**
     * URL Slug
     *
     * Type: url_slug
     * Required: true
     * Codename: url_slug
     * Id: 1f693fe8-1a65-42d8-be57-ef9b1a7b682c
     */
    readonly url_slug: Elements.UrlSlugElement;
    /**
     * Parent Page
     *
     * Type: modular_content
     * Required: false
     * Codename: parent_page
     * Id: 1ca4c730-1e74-4671-bbdc-51823624dc2d
     */
    readonly parent_page: Elements.LinkedItemsElement<PageGeneral>;
  } & PageElements,
  "general_page"
>;

/**
 * Type representing all available element codenames for 📄 Page // General
 */
export type PageGeneralElementCodenames =
    | 'title'
    | 'intro'
    | 'image'
    | 'hero_type'
    | 'sections'
    | 'url_slug'
    | 'parent_page'
    | 'page_elements__meta_title'
    | 'page_elements__meta_description';

/**
 * Type guard for 📄 Page // General
 *
 * Id: 7d8ee9b7-7189-4e8f-92c6-1337339dc4ea
 * Codename: general_page
 */
export function isPageGeneral(item: CoreContentType | undefined | null): item is PageGeneral {
    return item?.system?.type === 'general_page';
}
